import * as React from 'react';
import { useLocation } from 'react-router-dom';
import AppSAML from './AppSAML';
const LoginSAML = () => {
    const location = useLocation();

    // Create a URLSearchParams instance from the search string
    const searchParams = new URLSearchParams(location.search);

    // Retrieve the 'Params' query parameter value
    const paramsValue = searchParams.get('Params') || undefined;
    return (
            <AppSAML  paramsValue={paramsValue} />
    );
};

export default LoginSAML;
